import { ZeneithDBCore } from "./Core/ZeneithDBCore.js";
export const ZeneithDB = {
    __initalized: false,
    core: ZeneithDBCore,
    async $INIT() {
        if (this.__initalized)
            return;
        await this.core.initialize();
        this.__initalized = true;
    },
    async databaseExists(dataBaseName) {
        return await this.core.dataBaseExist(dataBaseName);
    },
    async createDatabase(data) {
        return await this.core.createDataBase(data);
    },
    async updateDatabase(data) {
        return await this.core.createDataBase(data);
    },
    async getDatabase(name) {
        return await this.core.getDataBase(name);
    },
    async deleteDatabase(name) {
        return await this.core.deleteDataBase(name);
    },
};
